import { useEffect } from "react";
import {
  CheckCircle,
  XCircle,
  AlertTriangle,
  Info,
  X
} from "lucide-react";

const TYPES = {
  success: {
    bg: "bg-emerald-500/15",
    border: "border-emerald-500",
    text: "text-emerald-400",
    icon: <CheckCircle size={20} />
  },
  error: {
    bg: "bg-red-500/15",
    border: "border-red-500",
    text: "text-red-400",
    icon: <XCircle size={20} />
  },
  warning: {
    bg: "bg-yellow-500/15",
    border: "border-yellow-500",
    text: "text-yellow-400",
    icon: <AlertTriangle size={20} />
  },
  info: {
    bg: "bg-sky-500/15",
    border: "border-sky-500",
    text: "text-sky-400",
    icon: <Info size={20} />
  }
};

const Notification = ({
  type = "info",
  title,
  message,
  onClose,
  duration = 4000
}) => {
  const style = TYPES[type];

  useEffect(() => {
    if (!duration) return;
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div
      className={`
        w-full max-w-sm
        ${style.bg}
        ${style.border}
        ${style.text}
        border
        rounded-lg
        shadow-lg
        p-4
        flex
        gap-3
        animate-slide-in
      `}
    >
      <div className="mt-0.5">{style.icon}</div>

      <div className="flex-1">
        {title && (
          <p className="font-semibold text-sm">
            {title}
          </p>
        )}
        {message && (
          <p className="text-sm opacity-90">
            {message}
          </p>
        )}
      </div>

      <button
        onClick={onClose}
        className="opacity-70 hover:opacity-100 transition"
      >
        <X size={18} />
      </button>
    </div>
  );
};

export default Notification;
